import React from 'react';
import { SpecialRatesGrid } from './SpecialRatesGrid';
import {
  getSpecialRates,
  saveSpecialRatesBatch,
  addSpecialRatesRange,
} from '../../api/specialRates';

export function SpecialRatesTenantPage() {
  return (
    <SpecialRatesGrid
      resourceCode="specialRates"
      titleKey="specialRates.tenantPageTitle"
      getRows={getSpecialRates}
      saveBatch={saveSpecialRatesBatch}
      addRange={addSpecialRatesRange}
    />
  );
}
